<template>
  <el-row v-loading="loading">
    <el-row class="padding_5px_top padding_10px_bottom">
      <el-col :span="20">
        <el-col
          :span="24"
          class="left_text_align"
        >
        <el-col
          :span="5"
          class="left_text_align"
        >
        <el-select
              class="fundSelector_Company"
              v-model="full"
              placeholder="请选择"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
        </el-col>
              <el-col
        :span="5"
        style="margin-left:20px"
        class="left_text_align searchInput"
      >
        <el-popover
          placement="bottom"
          width="380px"
          v-model="searchPopoverVisible"
        >
          <el-row
            style="width: 380px; height: 300px;"
            v-loading="loading2"
          >
            <el-scrollbar
              ref="search_scrollbar"
              style="height: 100%;"
            >
              <el-row
                style="
                                    text-align: left;
                                    margin: 0;
                                    font-size: 12px;
                                    cursor: pointer;
                                "
                v-for="(node, index) in state"
                class="fundInformation"
                :key="index"
              >
                <el-col
                  :span="24"
                  v-html="node"
                  @click.native="
                                        selectSymbolAutoComplete(node)
                                    "
                  :ref="'cssClass' + index"
                  @mouseenter.native="
                                        changeClass($event, index)
                                    "
                  :class="{ searchHover: 1 === index }"
                ></el-col>
              </el-row>
            </el-scrollbar>
          </el-row>
          <el-input
            placeholder="请输入基金代码或基金名称"
            slot="reference"
            type="text"
            v-model="searchKey"
            @input="searchFundCache(searchKey, true)"
            @keyup.enter.native="submitSearch"
          ></el-input>
        </el-popover>
      </el-col>
        
        <el-col
          :span="5"
          style="margin-left:10px">
          <span class="title_effective_date padding_10px_left_righ">评估时间：{{effectiveDate}}
          </span>    
        </el-col>
        </el-col>

      </el-col>
<el-col
          :span="4">
          <span class="right_text_align">
            <el-button
              icon="icon_export"
              @click="downloadFile"
              :disabled="disableExport"
            >导出数据列表</el-button>
          </span>
        </el-col>
    </el-row>
    <div class="table-line"
      style="margin-top:15px;"></div>
    <el-table
      :data="tableData"
      border
      @sort-change="sortChange"
      :default-sort="{ prop: 'defaultSymbol', order: 'descending' }"
      style="width: 100%;"
      class="tableSpecial"   
    >
      <el-table-column
        fixed
        sortable="custom"
        prop="defaultSymbol"
        label="基金代码"
        width="120"
      ><template slot-scope="scope">
          <el-button
            @click="
                            redirectRiskLevelDataBase(scope.row.defaultSymbol)
                        "
            type="text"
            size="small"
          >{{ scope.row.defaultSymbol }}</el-button>
        </template>
      </el-table-column>
      <el-table-column
        fixed
        prop="className"
        label="基金名称"
        width="241"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        fixed
        prop="specialCategory"
        label="基金类型"
        width="150px"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        label="持仓风险"
        align="center"
        label-class-name="col-divider-left"
      >
        <el-table-column
          prop="CateScore"
          label="得分"
          min-width="75"
          sortable="custom"
          align="center"
          class-name="col-divider-left"
          label-class-name="col-divider-left"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.CateScore | fillNull }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="CateWeight"
          label="权重"
          min-width="75"
          sortable="custom"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.CateWeight | fillNull }}</span>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column
        label="波动风险"
        align="center"
        label-class-name="col-divider-left"
      >
      <el-table-column
          prop="STD"
          label="标准差"
          min-width="120"
          sortable="custom"
          align="center"
          class-name="col-divider-left"
          label-class-name="col-divider-left"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.STD | fillNull }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="stdRankP"
          label="排名%"
          min-width="75"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.stdRankP == "" ? "--":scope.row.stdRankP}}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="STDScore"
          label="得分"
          min-width="75"
          sortable="custom"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.STDScore | fillNull }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="STDWeight"
          label="权重"
          min-width="75"
          sortable="custom"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.STDWeight | fillNull }}</span>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column
        label="晨星风险"
        align="center"
        label-class-name="col-divider-left"
      >
      <el-table-column
          prop="MRAR_Risk"
          label="晨星风险"
          min-width="120"
          sortable="custom"
          align="center"
          class-name="col-divider-left"
          label-class-name="col-divider-left"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.MRAR_Risk | fillNull }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="maraRiskRankP"
          label="排名%"
          min-width="75"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.maraRiskRankP == "" ? "--":scope.row.maraRiskRankP }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="MRAR_RiskScore"
          label="得分"
          min-width="75"
          sortable="custom"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.MRAR_RiskScore | fillNull }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="MRAR_RiskWeight"
          label="权重"
          min-width="75"
          sortable="custom"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.MRAR_RiskWeight | fillNull }}</span>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column
        label="下跌风险"
        align="center"
        label-class-name="col-divider-left"
      >
      <el-table-column
          prop="DR"
          label="下行标准差"
          min-width="120"
          sortable="custom"
          align="center"
          class-name="col-divider-left"
          label-class-name="col-divider-left"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.DR | fillNull }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="drRankP"
          label="排名%"
          min-width="75"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.drRankP == "" ? "--":scope.row.drRankP }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="DRScore"
          label="得分"
          min-width="75"
          sortable="custom"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.DRScore | fillNull }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="DRWeight"
          label="权重"
          min-width="75"
          sortable="custom"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.DRWeight | fillNull }}</span>
          </template>
        </el-table-column>
      </el-table-column>

      <el-table-column
        label="业绩回撤风险"
        align="center"
        label-class-name="col-divider-left"
      >
      <el-table-column
          prop="MDD"
          label="最大回撤（成立以来）"
          min-width="200"
          sortable="custom"
          align="center"
          class-name="col-divider-left"
          label-class-name="col-divider-left"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.MDD | formatMDD }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="MDD3" label="最大回撤（最近三年）" min-width="190" sortable="custom" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.MDD3 | fillNull }}</span>
          </template>
        </el-table-column>

        <el-table-column
          prop="ExtraScore_MDD3"
          label="附加分"
          min-width="120"
          sortable="custom"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ getExtraScore(scope.row) | fillNull }}</span>
          </template>
        </el-table-column>
      </el-table-column>

      <el-table-column
        prop="ExtraScore_HEP"
        label="高权益仓位风险"
        width="150px"
        sortable="custom"
        class-name="col-divider-left"
        label-class-name="col-divider-left"
        align="center"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.ExtraScore_HEP | fillNull }}</span>
        </template>
      </el-table-column>

      <el-table-column
        label="规模风险"
        align="center"
        label-class-name="col-divider-left"
      >
      <el-table-column
          prop="TNA"
          label="基金规模|(亿元)"
          min-width="150"
          :render-header="renderheader2Row"
          sortable="custom"
          align="center"
          class-name="col-divider-left"
          label-class-name="col-divider-left"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.TNA | formatTNA }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="TNAScore"
          label="附加分"
          min-width="120"
          sortable="custom"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.TNA , scope.row.TNAScore * scope.row.TNAWeight | fillNullForTNA }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column
          prop="TNAWeight"
          label="权重"
          min-width="75"
          sortable="custom"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.TNAWeight | fillNull }}</span>
          </template>
        </el-table-column> -->
      </el-table-column>
 
      <el-table-column
        label="综合风险"
        align="center"
        label-class-name="col-divider-left"
      >
        <el-table-column
          prop="totalScore"
          label="得分"
          min-width="75"
          sortable="custom"
          align="center"
          class-name="col-divider-left"
          label-class-name="col-divider-left"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.totalScore | fillNull }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="totalRisk"
          label="等级"
          min-width="75"
          sortable="custom"
          align="center"
        >
        </el-table-column>
      </el-table-column>
    </el-table>
    <el-col class="left_text_align padding_25px_top">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="params.page"
        :page-sizes="[10, 20, 50, 100, 200]"
        :page-size="pagination.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="(pagination && pagination.count) || 0"
        v-if="pagination.count > 10 ? true : false"
      >
      </el-pagination>
      <el-dialog
          :visible.sync="exportDialogVisible"
          width="350px"
          center
          :modal-append-to-body="true"
          custom-class="customDialog"
          :show-close="false"
        >
          <el-row v-loading="exportDialogLoading">
            <el-row>
              <el-col
                class="dialog_title"
                style="
                      padding-bottom: 16px;
                      font-size: 14px;
                      font-weight: bold;
                      text-align: center;"
              >导出格式</el-col>
              <el-col
                :span="24"
                class=""
              >
                <el-select
                  v-model="selectFormat"
                  class="export_inputBox"
                  style="width: 100%;"
                >
                  <el-option
                    selected="selected"
                    label="Excel"
                    value="xlsx"
                  ></el-option>
                  <el-option
                    label="CSV"
                    value="csv"
                  ></el-option>
                  <el-option
                    label="PDF"
                    value="pdf"
                  ></el-option>
                </el-select>
              </el-col>
            </el-row>
            <el-row>
              <el-col
                :span="11"
                class="right_text_align"
              >
                <el-button
                  size="small"
                  class="button_space"
                  round
                  @click="exportDialogVisible = false"
                >取 消</el-button>
              </el-col>
              <el-col
                :span="13"
                class="left_text_align"
                style="padding-left: 20px;"
              >
                <el-button
                  size="small"
                  class="button_space"
                  type="primary"
                  round
                  @click="handleExportFile(selectFormat)"
                >导 出</el-button>
              </el-col>
            </el-row>
          </el-row>
        </el-dialog>
      </el-col>
  </el-row>
</template>
<script>
import { Message } from "element-ui";
import {
    getRiskDetail,
    getRiskDetailBySymbol,
    downloadRiskDetailExcelFile
} from "../../api/suitability";

import { importFile } from "./mixin/importFile";
import { frequencyConfig } from "./mixin/frequencyConfig";

const componentsCommon=require("cb-components-common").default;
const checkResponseStatus=componentsCommon.common.checkResponseStatus;
const getDisableExport=componentsCommon.common.getDisableExport;
const getSuitabilityMemberBaseTrial = componentsCommon.common.getSuitabilityMemberBaseTrial;
const getSuitabilityMemberSeniorTrial = componentsCommon.common.getSuitabilityMemberSeniorTrial;
const fetchFile=componentsCommon.downloadUtils.fetchFile;
const SearchByAutoComplete=componentsCommon.search.SearchByAutoComplete;
const removeNameAndValue=componentsCommon.localStorage.removeNameAndValue;
const setNameAndValue=componentsCommon.localStorage.setNameAndValue;
const getNameAndValue=componentsCommon.localStorage.getNameAndValue;
const getFundCache=componentsCommon.apiCommon.getFundCacheRiskDetailForMyList;
const searchBox=componentsCommon.mixin.searchBox.searchBox;
const exportFile = componentsCommon.mixin.exportFile.exportFile;

export default {
    mixins: [importFile, exportFile, frequencyConfig, searchBox],
    data() {
        return {
          options: [
            // {
            //   value: 3,
            //   label: '我的列表'
            // },
            {
              value: 0,
              label: '自定义'
            }, 
            {
              value: 1,
              label: '基金公司'
            },
            {
              value: 2,
              label: '全市场基金'
            }],
            exportDialogVisible: false,
            exportDialogLoading: false,
            searchKey: "",
            searchPopoverVisible: false,
            downloadAllVisible: false,
            dialogLoading: false,
            symbolList: [],
            effectiveDate: "",
            configSendDialogVisible: false,
            importDialogVisible: false,
            exportDialogVisible: false,
            ftpDialogVisible: false,
            loading: false,
            full: null,
            tableData: [],
            pageSize: 0,
            selectFormat: "xlsx",
            pagination: {
                skip: 0,
                limit: 10,
                count: 0,
            },
            params: {
                searchKey: "",
                sort: "ClassName",
                order: "asc",
                limit: 10,
                skip: 0,
                page: 1,
                full: 3
            },
            disableExport:true,
        };
    },
    filters: {
        formatTNA(value) {
          if (value != undefined && value != null) {
                return (value / 100000000).toFixed(2);
            } else {
                return "--";
            }
        },
        fillNullForTNA(TNAvalue,value) {
          if (TNAvalue != undefined && TNAvalue != null) {
               TNAvalue = (TNAvalue/ 100000000).toFixed(2);
            } else {
                TNAvalue = "--";
            }
          if (TNAvalue === "--") {
                return "--";
            } else if (value !== undefined && value !== null) {
                return value.toFixed(2);
            } else {
                return "--";
            }
        },
        formatMDD(value) {
          if (value != undefined && value != null) {
                return (value * 100).toFixed(2);
            } else {
                return "--";
            }
        },
        fillNull(value) {
          if (value !== undefined && value !== null) {
                return value.toFixed(2);
            } else {
                return "--";
            }
        },
        replaceTime(value) {
            if (value != undefined && value != null && value != "") {
                return value.replace("00:00:00.0", "");
            } else {
                return "--";
            }
        },
    },
    mounted() {
        const self = this;
        self.getData(self.params);
        
        if(getDisableExport()||getSuitabilityMemberSeniorTrial())
        {
          this.disableExport = true;
        }
        else
        {
          this.disableExport = false;
        }
    },
     watch: {
       full: function(val) {
          const self = this;
          self.params.full = self.full;
          self.getData(self.params);
          self.searchFundCache(self.searchKey, self.params.full);
        },

    },
    methods: {
      getExtraScore(row) {
          if (row && row.ExtraScore_MDD3 !== undefined && row.ExtraScore_MDD3 !== null && row.ExtraScore_MDD3 !== "") {
              return row.ExtraScore_MDD3;
          }
          if (row && row.ExtraScore !== undefined && row.ExtraScore !== null && row.ExtraScore !== "") {
              return row.ExtraScore;
          }
          return undefined;
      },
      submitSearch() {
            let self = this;
            self.loading = true;
            self.searchPopoverVisible = false;
            self.params.searchKey = self.searchKey;
            self.getData(self.params);
        },
        loadingData() {
            const self = this;
            self.getData(self.params);
        },
        downloadFile() {
          const self = this;
            let fileName = "子项风险.xlsx";
            let fileType = "application/octet-stream;charset=utf-8";
            downloadRiskDetailExcelFile(self.params)
                .then(response => {
                    let data = response.data;
                    if (response.status == 200) {
                        fetchFile(data, fileType, fileName);
                        Message({
                            message: "文件名：" + fileName + ",下载成功！",
                            type: "success",
                            duration: 5 * 1000
                        });
                        Message.close = function() {
                        };
                    }
                    self.loading = false;
                })
                .catch(err => {
                    self.loading = false;
                    Message({
                        message: "数据异常，请尝试刷新再试！",
                        type: "error",
                        duration: 2 * 1000
                    });
                    Message.close = function() {};
                })
                .finally(r => {
                    self.loading = false;
                });
        },
        getData(params) {
          const self = this;
          self.loading = true;
          self.params.searchKey = '';
          getRiskDetail(params)
            .then((response) => {
              let result = response.data;
              // 先假定无数据，清空
              self.tableData = [];
              self.pageSize = 0;
              self.effectiveDate = "";
              self.pagination = { skip: 0, limit: 10, count: 0 };

              if (result && checkResponseStatus(result, self)) {
                if (Number(result._meta.response_status) === 200032) {
                  Message({
                    message: "非常抱歉，数据正在更新中，请稍后再试！",
                    type: "warning",
                    duration: 3 * 1000,
                  });
                  Message.close = function () { };
                } else if (result.data && Array.isArray(result.data.riskDetail)) {
                  self.tableData = result.data.riskDetail;
                  self.pagination = result.pagination || self.pagination;
                  self.pageSize = (result.pagination && result.pagination.count) || 0;
                  if (result.data.riskDetail.length > 0) {
                    self.effectiveDate = result.data.riskDetail[0].effectiveDate;
                  }
                }
              } else if (result == undefined) {
                Message({
                  message: "数据异常，请尝试刷新再试！",
                  type: "error",
                  duration: 2 * 1000,
                });
                Message.close = function () { };
              }
            })
            .catch((err) => {
              // 出错也要清空
              // self.tableData = [];
              // self.pageSize = 0;
              // self.effectiveDate = "";
              // self.pagination = { skip: 0, limit: 10, count: 0 };
              Message({
                message: "数据异常，请尝试刷新再试！",
                type: "error",
                duration: 2 * 1000,
              });
              Message.close = function () { };
            })
            .finally((r) => {
              self.loading = false;
            });
        },
        handleSizeChange(val) {
            const self = this;
            self.params.limit = val;
            self.getData(self.params);
        },
        handleCurrentChange(val) {
            const self = this;
            self.params.page = val;
            self.params.skip = (val - 1) * self.params.limit;
            self.getData(self.params);
        },
        sortChange(column, prop, order) {
            let self = this;
            if (column.order != undefined) {
                self.params.order = column.order
                    .replace("ascending", "asc")
                    .replace("descending", "desc");
                self.params.sort = column.prop;
                self.getData(self.params);
            }
            console.log(column + "-" + column.prop + "-" + column.order);
        },
        redirectRiskLevelDataBase(symbol) {
            this.$emit("redirectRiskLevelDataBase", symbol);
        },
        searchFundCache(queryString, popoverVisible) {
            let self = this;
            if (queryString !== undefined && queryString.length > 0) {
                self.searchPopoverVisible = popoverVisible;
                self.loading2 = true;
                queryString = queryString.trim();
                clearTimeout(self.timeout);
                self.timeout = setTimeout(() => {
                    getFundCache({ keyword: queryString, custom: self.params.full })
                        .then((response) => {
                            let result = response.data;
                            if (result == undefined) {
                                Message({
                                    message: "数据异常，请尝试刷新再试！",
                                    type: "error",
                                    duration: 2 * 1000,
                                });
                                Message.close = function () {};
                            } else {
                                if (checkResponseStatus(result, self)) {
                                    self.symbolList = result.data;
                                    self.searchDataByAutoComplete(queryString);
                                }
                            }
                        })
                        .catch((x) => {
                            Message({
                                message: "网络超时，请重新尝试！",
                                type: "error",
                                duration: 3 * 1000,
                            });
                            Message.close = function () {};
                        })
                        .finally((r) => {
                            self.loading2 = false;
                        });
                }, 500);
            }
        },
        searchDataByAutoComplete(queryString) {
            const self = this;
            let results = self.symbolList;
            self.state.length = 0;
            self.state.push(
                "<span class='searchbox_symbol font_bold'>基金代码</span><span class='searchbox_title font_bold' style='min-width: 280px; width: 280px;'>基金名称</span>"
            );
            if (results !== undefined) {
                for (let i = 0; i < results.length; i++) {
                    const value = results[i].symbol + "    " + results[i].name;
                    let htmlString = value.replace(
                        queryString,
                        "<b style='color:red;'>" + queryString + "</b>"
                    );
                    htmlString = htmlString.replace(
                        "    ",
                        "</span><span class='searchbox_title' style='min-width: 280px; width: 280px;'>"
                    );
                    if (i === 0) {
                        self.firstSymbol = results[i].symbol;
                        self.state.push(
                            "<span class='searchbox_symbol'>" +
                                htmlString +
                                "</span>"
                        );
                    } else {
                        self.state.push(
                            "<span class='searchbox_symbol'>" +
                                htmlString +
                                "</span>"
                        );
                    }
                }
            }
            if (results === undefined || results.length === 0) {
                self.state.length = 0;
                self.state.push(
                    "<div class='center_text_align'>抱歉，没有找到和" +
                        "<b style='color:red;'>" +
                        queryString +
                        "</b>" +
                        "相关的内容</div>"
                );
            }
            self.$refs.search_scrollbar.update();
        },
        selectSymbolAutoComplete(symbolValue) {
            const self = this;
            if (
                symbolValue.indexOf(
                    "</span><span class='searchbox_title' style='min-width: 280px; width: 280px;'>"
                ) > -1
            ) {
                self.loading = true;
                self.searchPopoverVisible = false;
                symbolValue = symbolValue.split(
                    "</span><span class='searchbox_title' style='min-width: 280px; width: 280px;'>"
                )[0];
                symbolValue = symbolValue
                    .replace("<b style='color:red;'>", "")
                    .replace("<span class='searchbox_symbol'>", "")
                    .replace("</b>", "");
                self.params.searchKey = symbolValue;    
                self.getRiskDetailBySymbol(self.params);
            }
        },
        getRiskDetailBySymbol(params) {
          const self = this;
          getRiskDetail(params)
                    .then((response) => {
                        let result = response.data;
                        if (result == undefined) {
                            Message({
                                message: "数据异常，请尝试刷新再试！",
                                type: "error",
                                duration: 2 * 1000,
                            });
                            Message.close = function () {};
                        } else {
                            if (checkResponseStatus(result, self)) {
                                if (result.pagination != undefined) {
                                    self.pagination = result.pagination;
                                    self.pagination.count = 1;
                                }
                                self.tableData = result.data.riskDetail;
                                if(result.data.riskDetail.length > 0) {
                                  self.effectiveDate = result.data.riskDetail[0].effectiveDate;
                                }
                            }
                        }
                    })
                    .catch((err) => {
                        Message({
                            message: "数据异常，请尝试刷新再试！",
                            type: "error",
                            duration: 2 * 1000,
                        });
                        Message.close = function () {};
                    })
                    .finally((r) => {
                        self.loading = false;
                    });
        }
    },
};
</script>
<style lang="scss">
@import "../../public/sass/components/latestEvaluation";
@import "../../public/sass/components/fundSelector";
</style>
<style scoped>
.tableSpecial >>> table tr:nth-child(1) {
    line-height: 35px;
}

.tableSpecial >>> .col-divider-left {
  border-left: 1px solid #ebeef5 !important;
}

.el-checkbox_overwrite >>> .el-checkbox__inner {
    width: 24px !important;
    height: 24px !important;
}
</style>